import { useEffect, useRef } from 'react';
import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';
export const DrawingManager = ({ options, onPolygonComplete, }) => {
    const map = useMap();
    const drawing = useMapsLibrary('drawing');
    const managerRef = useRef(null);
    useEffect(() => {
        if (!map || !drawing)
            return undefined;
        const manager = new drawing.DrawingManager({ drawingControl: true });
        manager.setMap(map);
        managerRef.current = manager;
        return () => {
            manager.setMap(null);
            managerRef.current = null;
        };
    }, [map, drawing]);
    useEffect(() => {
        if (!managerRef.current || !options)
            return;
        managerRef.current.setOptions(options);
    }, [options]);
    useEffect(() => {
        const manager = managerRef.current;
        if (!manager || !onPolygonComplete)
            return undefined;
        const listener = google.maps.event.addListener(manager, 'polygoncomplete', onPolygonComplete);
        return () => google.maps.event.removeListener(listener);
    }, [map, drawing, onPolygonComplete]);
    return null;
};
